import { FlightsWithVersionInfos } from '../models/flightswithversioninfos.model';
import { Person } from '../models/person.model';
import { Tandem } from '../models/tandem.model';
import { UpdateFlightsRequest } from '../models/updateflightsrequest.model';
import { UpdateFlightsResponse } from '../models/updateflightsresponse.model';
import { BaseService } from './base.service';

class ManifestV1Service extends BaseService {

  async getFlights(): Promise<FlightsWithVersionInfos> {
    const headers = this.getHeaders();
    const API_URL = '/api/flights-with-version';
    try {
      const response = await fetch(API_URL, { headers: headers });
      if (!response.ok) {
        throw new Error(`HTTP status : ${response.status}`);
      }

      const data: FlightsWithVersionInfos = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async getPilots(): Promise<Person[]> {
    const headers = this.getHeaders();
    const API_URL = '/api/pilots';
    try {
      const response = await fetch(API_URL, { headers: headers });
      if (!response.ok) {
        throw new Error(`HTTP status : ${response.status}`);
      }

      const data: Person[] = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async getTeams(): Promise<Person[]> {
    const headers = this.getHeaders();
    const API_URL = '/api/teams';
    try {
      const response = await fetch(API_URL, { headers: headers });
      if (!response.ok) {
        throw new Error(`HTTP status : ${response.status}`);
      }

      const data: Person[] = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async getJumpMasters(): Promise<Person[]> {
    const headers = this.getHeaders();
    const API_URL = '/api/jump-masters';
    try {
      const response = await fetch(API_URL, { headers: headers });
      if (!response.ok) {
        throw new Error(`HTTP status : ${response.status}`);
      }

      const data: Person[] = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async getTandems(): Promise<Tandem[]> {
    const headers = this.getHeaders();
    const API_URL = '/api/tandems';
    try {
      const response = await fetch(API_URL, { headers: headers });
      if (!response.ok) {
        throw new Error(`HTTP status : ${response.status}`);
      }

      const data: Tandem[] = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async updateFlights(ufr: UpdateFlightsRequest): Promise<UpdateFlightsResponse> {
    const headers = this.getHeaders();
    const API_URL = '/api/update-flights';
    try {
      const response = await fetch(API_URL,
        {
          method: "POST",
          body: JSON.stringify(ufr),
          headers: headers
        });

      if (!response.ok) {
        throw new Error(`HTTP status: ${response.status}`);
      }

      const data: UpdateFlightsResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async printWeightAndBalance(flightId: number, nb: number): Promise<UpdateFlightsResponse> {
    const headers = this.getHeaders();
    const API_URL = '/api/print-wb';
    try {
      const response = await fetch(API_URL,
        {
          method: "POST",
          body: JSON.stringify({
            flightId,
            nb
          }),
          headers: headers
        });

      if (!response.ok) {
        throw new Error(`HTTP status: ${response.status}`);
      }

      const data: UpdateFlightsResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async downloadWeightAndBalance(flightId: number): Promise<void> {
    const headers = this.getHeaders();
    headers['Accept'] = 'application/pdf';
    const API_URL = '/api/get-wb';
    try {
      const response = await fetch(API_URL,
        {
          method: "POST",
          body: JSON.stringify({
            flightId
          }),
          headers: headers
        });

      if (!response.ok) {
        throw new Error(`HTTP status: ${response.status}`);
      }
      console.log('blob response');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `weight-and-balance-${flightId}.pdf`;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }

  async doCall(text: string): Promise<string> {
    const headers = this.getHeaders();
    const API_URL = '/api/do-voice-call';
    const voiceCallRequest = {
      id: Math.random().toString(16).slice(2),
      text: text
    };
    try {
      const response = await fetch(API_URL,
        {
          method: "POST",
          body: JSON.stringify(voiceCallRequest),
          headers: headers
        });

      if (!response.ok) {
        throw new Error(`HTTP status: ${response.status}`);
      }

      const data: string = await response.text();
      return data;
    } catch (error) {
      console.error('Error : ', error);
      throw error;
    }
  }
}

export default new ManifestV1Service();